import { useEffect } from 'react'
import * as store from '@store'
import { useWireValue } from '@forminator/react-wire'
import { RT_EVENT_TYPE_UPDATE_CHECK_REPORT_STATUS } from '@/constants'

// @todo: would be interesting if we have a store for checkReports
const useRealtimeCheckReportStatus = (reports, setReports) => {
    const notifications = useWireValue(store.notifications)
    const remoteConfig = useWireValue(store.remoteConfig)
    
    useEffect(() => {
        
        if (!remoteConfig?.realtimeEnabled) return
        
        const updateCheck = async () => {
            
            if (!reports) return
            
            const latestNotification = notifications
                .filter(
                    notification => notification.message.data.type === RT_EVENT_TYPE_UPDATE_CHECK_REPORT_STATUS,
                )
                .sort((a, b) => new Date(b.message.data.data.createdAt) - new Date(a.message.data.data.createdAt))[0]
            
            if (!latestNotification) return
            
            const { status: latestStatus, checkReportId } = latestNotification.message.data.data
            
            const reportToUpdate = reports.rows.find(it => it.id === checkReportId)
            
            if (reportToUpdate && reportToUpdate.status !== latestStatus)
                setReports(prev => ({
                    count: prev?.count ?? 0,
                    rows: (prev?.rows ?? []).map(it => {
                        if (it.id !== checkReportId) return it
                        return {
                            ...it,
                            status: latestStatus,
                        }
                    }),
                }))
            
        }
        
        updateCheck()
        
    }, [reports, notifications])
    
}

export default useRealtimeCheckReportStatus
